"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Radio = _interopRequireDefault(require("../Radio/Radio"));

var _keyHelpers = require("../../utils/keyHelpers");

var _genderConfig = require("./genderConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var GenderDefinition = _flowRuntime["default"].tdz(function () {
  return _genderConfig.GenderDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("gender", _flowRuntime["default"].ref(GenderDefinition)), _flowRuntime["default"].property("parentKey", _flowRuntime["default"].string(), true)));

var Gender = function Gender(_arg) {
  var gender = _arg.gender,
      parentKey = _arg.parentKey;
  var componentKey = (0, _keyHelpers.compositeKey)(parentKey, gender.key);
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    id: componentKey
  }, /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
    key: gender.key,
    radio: _genderConfig.genderRadio
  }));
};

Gender.defaultProps = {
  parentKey: undefined
};
var _default = Gender;
exports["default"] = _default;